/*jshint esversion:6 */
import React from "react";
import Moment from "moment";
import ATable from "../../common/table";
import Constants from "../../../configurations/constants";

const SettlementReportsTable = props => {
  const columns = [
    {
      header: "S/N",
      width: 50,
      render: row => <div>{props.paginatedCallback(row.viewIndex)}</div>
    },
    {
      header: "Search Criteria",
      accessor: "logCode",
      render: row => {
        return (
          <div>
            {row.row.logCode && (
              <p>
                <strong>Log Code: </strong>
                {row.row.logCode}
              </p>
            )}
            {row.row.startDate &&
              row.row.endDate && (
                <p>
                  <strong>Date range:</strong>
                  <br />
                  {Moment(row.row.startDate).format(
                    Constants.DATE_FORMAT_LONG
                  )}{" "}
                  - {Moment(row.row.endDate).format(Constants.DATE_FORMAT_LONG)}
                </p>
              )}
          </div>
        );
      },
      width: 250
    },
    {
      header: "Report Type",
      accessor: "reportType",
      render: row => {
        return row.row.reportType;
      },
      width: 90
    },
    {
      header: "Status",
      accessor: "status",
      render: row => {
        return row.row.status;
      },
      width: 90
    },
    {
      header: " File name",
      accessor: "fileName",
      render: row => {
        return row.row.fileName
          ? row.row.fileName
          : "-- Report not available --";
      }
    },
    {
      header: "Created By",
      accessor: "createdBy",
      render: row => {
        return row.row.createdBy;
      }
    },
    {
      header: "Created On",
      accessor: "createdOn",
      render: row => {
        return Moment(row.row.createdOn).format(Constants.DATE_FORMAT_LONG);
      }
    },
    {
      header: "",
      accessor: "action",
      render: row => {
        const dateDifference = Moment().diff(Moment(row.row.createdOn));
        const isValidPending =
          dateDifference < Constants.SETTLEMENT_REPORT_MAXTIME;
        return (
          <div>
            {row.row.status.toLowerCase() ===
            Constants.SETTLEMENT_REPORT_STATUS.COMPLETED ? (
              <button
                className="btn-link"
                onClick={() => {
                  props.downloadReports(row.row.fileName);
                }}
              >
                Download
              </button>
            ) : (row.row.status.toLowerCase() ===
              Constants.SETTLEMENT_REPORT_STATUS.PENDING ||
              row.row.status.toLowerCase() ===
                Constants.SETTLEMENT_REPORT_STATUS.PROCESSING) &&
            isValidPending ? (
              <span className="text-info">In progress...</span>
            ) : (
              <button
                className="btn-link"
                onClick={() => {
                  props.retryReportGeneration(row.row.id);
                }}
              >
                Retry
              </button>
            )}
          </div>
        );
      }
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.settlementReports}
      columns={columns}
      onChange={props.onTableChange || null}
      manual
      {...props}
    />
  );
};

export default SettlementReportsTable;



// WEBPACK FOOTER //
// ./src/components/settlement/settlementReports/settlementReportsTable.js